import { Text } from 'platform-components';
import React from 'react';

import './assignment__collapsed.scss';

export const CollapsedMes = () => {
    return (
        <div className="assignment__dates-placeholder">
            <Text id="assignLessonModal.mes.dateInMes" />
        </div>
    );
};
